import * as React from 'react';
import { ResultItem } from '../../types';
import Show from '../../show';

export type Props = {
    resultItem: ResultItem;
    phone?: boolean;
};

export default function FinnResults(props: Props) {
    const { resultItem, phone } = props;
    const {
        adId,
        postalName,
        shortAddress,
        heading,
        primaryM2,
        mainPrice,
        totalPrice,
        sharedCost,
        svgLogo,
        logo,
        orgName,
        srcSet,
        mainImage,
    } = resultItem;

    return (
        <div
            className={`ads__unit ads__unit--framed  ${
                phone ? ' ads__unit--sponsored' : ''
            }`}
        >
            <div aria-owns={`result-item-heading-${adId}`} />

            <div className="ads__unit__img">
                <div className="ads__unit__img__ratio img-format img-format--ratio3by2  img-format--centered">
                    <img
                        src={mainImage}
                        className="img-format__img"
                        alt=""
                        srcSet={srcSet}
                        sizes="100vw"
                    />
                </div>
            </div>

            <div className="ads__unit__sponsored">Betalt plassering</div>

            <div className="ads__unit__content">
                <h2
                    className="ads__unit__content__title ads__unit__content__title--fav-placeholder"
                    id={`result-item-heading-${adId}`}
                >
                    {heading}
                </h2>
                <span className="ads__unit__content__details">
                    <span>
                        {shortAddress}, {postalName}
                    </span>
                </span>

                <p className="ads__unit__content__keys">
                    <span>{primaryM2}</span>
                    <span>{mainPrice}</span>
                </p>
                <p>
                    <span className="u-float-left">
                        <span className="ads__unit__content__list truncate">
                            {orgName}
                        </span>
                        <span className="ads__unit__content__list truncate">
                            <Show predicate={!!totalPrice}>
                                Totalpris: {totalPrice}
                            </Show>
                            <Show predicate={!!totalPrice && !!sharedCost}>
                                {' • '}
                            </Show>
                            <Show predicate={!!sharedCost}>
                                Fellesutg.: {sharedCost}
                            </Show>
                        </span>
                    </span>
                    <span className="u-hide-lt480 u-float-right">
                        <img
                            className="u-float-right"
                            style={{
                                maxHeight: '40px',
                                maxWidth: '75px',
                                minHeight: '40px',
                                minWidth: '40px',
                            }}
                            alt=""
                            src={svgLogo || logo}
                        />
                    </span>
                </p>
            </div>
        </div>
    );
}
